import { Star } from "lucide-react";

export default function StarRating({ value = 0, size = 16, onChange, editable = false }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={!editable}
          onClick={() => editable && onChange?.(n)}
          data-testid={editable ? `star-${n}` : undefined}
          className={editable ? "cursor-pointer" : "cursor-default"}
        >
          <Star
            size={size}
            className={n <= Math.round(value) ? "fill-[#E8956B] text-[#E8956B]" : "text-neutral-300"}
          />
        </button>
      ))}
    </div>
  );
}
